import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "clear-filter-button",
  class ClearFilterButton extends WYATTElement {
    constructor() {
      super();

      this.form = this.closest("form");

      this.data = JSON.parse(this.dataset.clearFilterButton);
      this.button = this.querySelector("button");
      this.label = this.querySelector('[data-template-element="label"]');

      this.setText();

      this.button.addEventListener("click", this.handleClick.bind(this));
    }

    setText() {
      this.label.textContent = this.data.filterValue;
    }

    handleClick(event) {
      event.preventDefault();

      const changeEvent = new Event("change", { bubbles: true });

      if (typeof this.data.value === "object") {
        const RangeFacet = this.form.querySelector(
          `[data-facet-field="${this.data.field}"][data-facet-label="${this.data.filterValue}"]`,
        );

        RangeFacet.setChecked(false);
      } else {
        const filter = this.form.querySelector(
          `[name="filter.${this.data.field}"][value="${this.data.value}"]`,
        );

        filter.checked = false;
      }

      this.form.dispatchEvent(changeEvent);
    }
  },
);
